import React, { useContext } from 'react';

import { AlertContext, CLEAR_ALERT } from '@agilemd/ui-alert';
import { isTruthy } from '@agilemd/ui-utils';

import Snackbar from './Snackbar.jsx';

export interface SnackbarManagerProps {
  /**
   * Any children to be rendered
   */
  children: React.ReactNode;
}

/**
 * Snackbars should only be shown one at a time.
 * This manager shows the snackbars (stored in AlertContext) one at a time
 */
const SnackbarManager: React.FC<SnackbarManagerProps> = ({ children }: SnackbarManagerProps) => {
  const { dispatchAlert, snackbars } = useContext(AlertContext);

  const snackbar = snackbars
    .filter(isTruthy)
    // NP only show one snackbar at a time
    .slice(0, 1)
    .map(({ id, message, onDismiss, action, placement, timeout, spacing }) => {
      const { label, onClick } = action || { onClick: () => 0 };

      return (
        <Snackbar
          onDismiss={() => {
            dispatchAlert({ type: CLEAR_ALERT, id });

            if (onDismiss) {
              onDismiss();
            }
          }}
          key={id}
          isActiveByDefault
          action={() => onClick(() => dispatchAlert({ type: CLEAR_ALERT, id }))}
          actionLabel={label}
          placement={placement}
          timeout={timeout}
          spacing={spacing}
        >
          {message}
        </Snackbar>
      );
    });

  return (
    <>
      {snackbar}
      {children}
    </>
  );
};

export default SnackbarManager;
